import { Button } from "V2.0/common/button";
import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Components/ConfigurationPanel";
import { formatTime } from "V2.0/utils";
import NodeExecutionStatusBadge from "../../../Components/NodeExecutionStatus";
import PreviewJson from "../../../Components/PreviewJson";

export default DefaultEndExecution;

function DefaultEndExecution(props) {
  const { node, nodeExecution, closePanel } = props;

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>{node.data.name}</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <div className="space-y-4">
          <div className="flex items-center gap-x-2">
            <p className="text-sm">Status:</p>
            <NodeExecutionStatusBadge status={nodeExecution.status} />
          </div>
          {nodeExecution.startTime && (
            <div className="flex items-center gap-x-2">
              <p className="text-sm">Start Time:</p>
              <p className="text-sm">{formatTime(nodeExecution.startTime)}</p>
            </div>
          )}
          {nodeExecution.endTime && (
            <div className="flex items-center gap-x-2">
              <p className="text-sm">End Time:</p>
              <p className="text-sm">{formatTime(nodeExecution.endTime)}</p>
            </div>
          )}
          {nodeExecution.input && (
            <PreviewJson
              title="Input"
              data={nodeExecution.input}
            />
          )}
        </div>
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end gap-x-2 items-center">
          <Button
            outline
            onClick={closePanel}
          >
            Close
          </Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
